import { summaryHasDetails } from '@src/features/transactables/summary/core/summaryHasDetails';
import { getSaleDiscountCents, isSaleCouponApplied, type Sale } from '@src/domains/sales';
import { shouldShowServiceFee } from '@src/domains/service-fees';

export const saleSummaryHasDetails = (sale: Sale | null | undefined, serviceFeeFeatureEnabled: boolean): boolean =>
  summaryHasDetails({
    discountCents: getSaleDiscountCents(sale),
    isCouponApplied: isSaleCouponApplied(sale),
    showServiceFee: shouldShowServiceFee(sale?.serviceFeeCurrencyInfo?.amountCents, serviceFeeFeatureEnabled),
  });
